import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { ItemType } from '@interfaces/search';

import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';

import LineMultimediaButton from './LineMultimediaButton';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { Document } from '@api/domain/types/imageHandling';
import { injectConditionalObject } from '@helpers';

const BlockHeader = ({
  C,
  documentData,
  itemDescription,
  itemMemo,
  itemType,
  onDeletePress,
  hideMoveHistoryBackButton = false,
  generateImageURL,
  scale = initialScale,
  font = initialFont,
}: {
  C: any;
  documentData?: Document | null;
  itemDescription?: string | null;
  itemMemo?: string | null;
  itemType?: ItemType;
  onDeletePress: () => void;
  hideMoveHistoryBackButton?: boolean;
  generateImageURL: any;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}) => {
  return (
    <View style={{ marginBottom: scale(31), paddingHorizontal: scale(18) }}>
      <Text numberOfLines={1} style={[font['Title 2'], { color: C('Label/Light/Secondary'), marginBottom: scale(10) }]}>
        {i18n.t('Part')}
      </Text>
      <LineMultimediaButton
        {...{
          scale,
          font,
          C,
          documentData: documentData,
          generateImageURL,
          bg: modalFieldBg,
          imgBg: 'Background / Light / Field',
          height: 66,
          title: itemDescription,
          text: itemMemo,
          shadow: false,
          ...injectConditionalObject(!hideMoveHistoryBackButton, {
            onAdditionalBtnPress: onDeletePress,
            additionalBtnIcon: 'xMark',
            additionalBtnColor: 'Label/Light/Primary',
          }),
        }}
      />
    </View>
  );
};

export default BlockHeader;
